import { render } from "./CoverageInfo.vue?vue&type=template&id=30f7daa1&scoped=true"
import script from "./CoverageInfo.vue?vue&type=script&lang=js"
export * from "./CoverageInfo.vue?vue&type=script&lang=js"

import "./CoverageInfo.vue?vue&type=style&index=0&id=30f7daa1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f7daa1"]])

export default __exports__